const tooltipTranslations = {
  en: {
    free: {
      title: "Vision Free",
      details:
        "Try for free with a one-time trial.\n" +
        "• 1 test video (max 30s and 50MB)\n" +
        "• Watermark required\n" +
        "• Basic dubbing available\n" +
        "• Ads displayed during processing\n" +
        "• May be available only during promotional periods\n" +
        "• Price: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Ideal for beginners needing more features.\n" +
        "• Up to 5GB monthly (60GB yearly)\n" +
        "• 2 videos/day (max 100MB each)\n" +
        "• Editing tools: cut and merge videos\n" +
        "• Basic dubbing with voice cloning\n" +
        "• Ads displayed at the start and end of processing\n" +
        "• Price: US$ 9.90 monthly or US$ 99.00 yearly"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Designed for small businesses or frequent creators.\n" +
        "• Up to 20GB monthly (240GB yearly)\n" +
        "• 5 videos/day (max 500MB each)\n" +
        "• Dubbing with voice cloning and lip-sync\n" +
        "• Ads displayed during upload and exit\n" +
        "• Perfect for consistent content production\n" +
        "• Price: US$ 69.90 monthly or US$ 699.00 yearly"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Full access to all features without restrictions.\n" +
        "• Up to 50GB monthly (600GB yearly)\n" +
        "• 10 videos/day (max 1GB each)\n" +
        "• Dubbing with voice cloning, lip-sync, and lip enhancement\n" +
        "• No forced ads and priority support\n" +
        "• Price: US$ 179.90 monthly or US$ 1,799.00 yearly"
    }
  },

  pt: {
    free: {
      title: "Vision Free",
      details:
        "Experimente gratuitamente com um teste único.\n" +
        "• 1 vídeo de teste (máx. 30s e 50MB)\n" +
        "• Marca d'água obrigatória\n" +
        "• Dublagem básica disponível\n" +
        "• Anúncios exibidos durante o processamento\n" +
        "• Pode estar disponível apenas em períodos promocionais\n" +
        "• Preço: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Ideal para iniciantes que precisam de mais funcionalidades.\n" +
        "• Até 5GB mensais (60GB anuais)\n" +
        "• 2 vídeos/dia (máx. 100MB cada)\n" +
        "• Ferramentas de edição: cortar e juntar vídeos\n" +
        "• Dublagem básica com voz clonada\n" +
        "• Anúncios exibidos no início e fim do processamento\n" +
        "• Preço: US$ 9,90 mensais ou US$ 99,00 anuais"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Projetado para pequenas empresas ou criadores frequentes.\n" +
        "• Até 20GB mensais (240GB anuais)\n" +
        "• 5 vídeos/dia (máx. 500MB cada)\n" +
        "• Dublagem com voz clonada e sincronia labial\n" +
        "• Anúncios exibidos durante o upload e ao sair da plataforma\n" +
        "• Perfeito para produção constante de conteúdo\n" +
        "• Preço: US$ 69,90 mensais ou US$ 699,00 anuais"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Acesso total a todas as funcionalidades sem restrições.\n" +
        "• Até 50GB mensais (600GB anuais)\n" +
        "• 10 vídeos/dia (máx. 1GB cada)\n" +
        "• Dublagem com voz clonada, sincronia labial e realce de lábios\n" +
        "• Sem anúncios forçados e suporte prioritário\n" +
        "• Preço: US$ 179,90 mensais ou US$ 1.799,00 anuais"
    }
  },

  es: {
    free: {
      title: "Vision Free",
      details:
        "Prueba gratuita con un test único.\n" +
        "• 1 video de prueba (máx. 30s y 50MB)\n" +
        "• Marca de agua obligatoria\n" +
        "• Doblaje básico disponible\n" +
        "• Anuncios mostrados durante el procesamiento\n" +
        "• Puede estar disponible solo en periodos promocionales\n" +
        "• Precio: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Ideal para principiantes que necesitan más funciones.\n" +
        "• Hasta 5GB mensuales (60GB anuales)\n" +
        "• 2 videos/día (máx. 100MB cada uno)\n" +
        "• Herramientas de edición: cortar y unir videos\n" +
        "• Doblaje básico con clonación de voz\n" +
        "• Anuncios al inicio y al final del procesamiento\n" +
        "• Precio: US$ 9,90 al mes o US$ 99,00 al año"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Diseñado para pequeñas empresas o creadores frecuentes.\n" +
        "• Hasta 20GB mensuales (240GB anuales)\n" +
        "• 5 videos/día (máx. 500MB cada uno)\n" +
        "• Doblaje con clonación de voz y sincronización labial\n" +
        "• Anuncios durante la carga y al salir\n" +
        "• Perfecto para producción constante de contenido\n" +
        "• Precio: US$ 69,90 al mes o US$ 699,00 al año"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Acceso total a todas las funciones sin restricciones.\n" +
        "• Hasta 50GB mensuales (600GB anuales)\n" +
        "• 10 videos/día (máx. 1GB cada uno)\n" +
        "• Doblaje con clonación de voz, sincronización labial y realce de labios\n" +
        "• Sin anuncios forzados y soporte prioritario\n" +
        "• Precio: US$ 179,90 al mes o US$ 1.799,00 al año"
    }
  },

  fr: {
    free: {
      title: "Vision Free",
      details:
        "Essayez gratuitement avec un essai unique.\n" +
        "• 1 vidéo d'essai (max 30s et 50MB)\n" +
        "• Filigrane obligatoire\n" +
        "• Doublage basique disponible\n" +
        "• Annonces affichées pendant le traitement\n" +
        "• Disponible uniquement lors des périodes promotionnelles\n" +
        "• Prix : US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Idéal pour les débutants ayant besoin de plus de fonctionnalités.\n" +
        "• Jusqu'à 5GB mensuels (60GB annuels)\n" +
        "• 2 vidéos/jour (max 100MB chacune)\n" +
        "• Outils d'édition : couper et assembler des vidéos\n" +
        "• Doublage basique avec clonage de voix\n" +
        "• Annonces au début et à la fin du traitement\n" +
        "• Prix : US$ 9,90 par mois ou US$ 99,00 par an"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Conçu pour les petites entreprises ou créateurs fréquents.\n" +
        "• Jusqu'à 20GB mensuels (240GB annuels)\n" +
        "• 5 vidéos/jour (max 500MB chacune)\n" +
        "• Doublage avec clonage de voix et synchronisation labiale\n" +
        "• Annonces lors du téléchargement et à la sortie\n" +
        "• Parfait pour une production de contenu régulière\n" +
        "• Prix : US$ 69,90 par mois ou US$ 699,00 par an"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Accès complet à toutes les fonctionnalités sans restrictions.\n" +
        "• Jusqu'à 50GB mensuels (600GB annuels)\n" +
        "• 10 vidéos/jour (max 1GB chacune)\n" +
        "• Doublage avec clonage de voix, synchronisation labiale et amélioration des lèvres\n" +
        "• Sans annonces imposées et support prioritaire\n" +
        "• Prix : US$ 179,90 par mois ou US$ 1.799,00 par an"
    }
  },

  de: {
    free: {
      title: "Vision Free",
      details:
        "Kostenlos testen mit einem einmaligen Versuch.\n" +
        "• 1 Testvideo (max. 30s und 50MB)\n" +
        "• Wasserzeichen erforderlich\n" +
        "• Basis-Dubbing verfügbar\n" +
        "• Werbung während der Verarbeitung\n" +
        "• Nur in Aktionszeiträumen verfügbar\n" +
        "• Preis: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Ideal für Anfänger, die mehr Funktionen benötigen.\n" +
        "• Bis zu 5GB monatlich (60GB jährlich)\n" +
        "• 2 Videos/Tag (max. 100MB pro Video)\n" +
        "• Bearbeitungstools: Videos schneiden und zusammenfügen\n" +
        "• Basis-Dubbing mit Stimmklonung\n" +
        "• Anzeigen zu Beginn und am Ende der Verarbeitung\n" +
        "• Preis: US$ 9,90 pro Monat oder US$ 99,00 pro Jahr"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Für kleine Unternehmen oder häufige Ersteller.\n" +
        "• Bis zu 20GB monatlich (240GB jährlich)\n" +
        "• 5 Videos/Tag (max. 500MB pro Video)\n" +
        "• Dubbing mit Stimmklonung und Lippen-Synchronisation\n" +
        "• Anzeigen beim Hochladen und Verlassen der Plattform\n" +
        "• Perfekt für regelmäßige Inhaltsproduktion\n" +
        "• Preis: US$ 69,90 pro Monat oder US$ 699,00 pro Jahr"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Voller Zugriff auf alle Funktionen ohne Einschränkungen.\n" +
        "• Bis zu 50GB monatlich (600GB jährlich)\n" +
        "• 10 Videos/Tag (max. 1GB pro Video)\n" +
        "• Dubbing mit Stimmklonung, Lippen-Synchronisation und Lippen-Verbesserung\n" +
        "• Keine erzwungenen Anzeigen und Prioritätsunterstützung\n" +
        "• Preis: US$ 179,90 pro Monat oder US$ 1.799,00 pro Jahr"
    }
  },

  it: {
    free: {
      title: "Vision Free",
      details:
        "Prova gratuita con un test unico.\n" +
        "• 1 video di prova (max 30s e 50MB)\n" +
        "• Filigrana obbligatoria\n" +
        "• Doppiaggio di base disponibile\n" +
        "• Annunci mostrati durante l'elaborazione\n" +
        "• Disponibile solo durante i periodi promozionali\n" +
        "• Prezzo: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Ideale per principianti che necessitano di più.\n" +
        "• Fino a 5GB al mese (60GB all'anno)\n" +
        "• 2 video/giorno (max 100MB ciascuno)\n" +
        "• Strumenti di editing: taglio e unione video\n" +
        "• Doppiaggio di base con clonazione vocale\n" +
        "• Annunci all'inizio e alla fine del processo\n" +
        "• Prezzo: US$ 9,90 al mese o US$ 99,00 all'anno"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Progettato per piccole aziende o creatori frequenti.\n" +
        "• Fino a 20GB al mese (240GB all'anno)\n" +
        "• 5 video/giorno (max 500MB ciascuno)\n" +
        "• Doppiaggio con clonazione vocale e sincronizzazione labiale\n" +
        "• Annunci durante il caricamento e all'uscita\n" +
        "• Perfetto per una produzione costante di contenuti\n" +
        "• Prezzo: US$ 69,90 al mese o US$ 699,00 all'anno"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Accesso completo a tutte le funzionalità senza restrizioni.\n" +
        "• Fino a 50GB al mese (600GB all'anno)\n" +
        "• 10 video/giorno (max 1GB ciascuno)\n" +
        "• Doppiaggio con clonazione vocale, sincronizzazione labiale e miglioramento labbra\n" +
        "• Nessuna pubblicità forzata e supporto prioritario\n" +
        "• Prezzo: US$ 179,90 al mese o US$ 1.799,00 all'anno"
    }
  },

  ru: {
    free: {
      title: "Vision Free",
      details:
        "Попробуйте бесплатно с одним тестом.\n" +
        "• 1 тестовое видео (макс. 30с и 50MB)\n" +
        "• Обязательный водяной знак\n" +
        "• Доступен базовый дубляж\n" +
        "• Реклама во время обработки\n" +
        "• Может быть доступно только в промо-периоды\n" +
        "• Цена: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Для новичков, которым нужно больше возможностей.\n" +
        "• До 5GB/месяц (60GB/год)\n" +
        "• 2 видео/день (до 100MB каждое)\n" +
        "• Обрезка и объединение видео\n" +
        "• Базовое озвучивание с клонированием голоса\n" +
        "• Реклама в начале и конце\n" +
        "• Цена: US$ 9,90 в месяц или US$ 99,00 в год"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Для малого бизнеса и частых создателей.\n" +
        "• До 20GB/месяц (240GB/год)\n" +
        "• 5 видео/день (до 500MB каждое)\n" +
        "• Озвучивание с клонированием голоса и синхронизацией губ\n" +
        "• Реклама при загрузке и выходе\n" +
        "• Идеально для постоянного создания контента\n" +
        "• Цена: US$ 69,90 в месяц или US$ 699,00 в год"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Полный доступ ко всем функциям.\n" +
        "• До 50GB/месяц (600GB/год)\n" +
        "• 10 видео/день (до 1GB каждое)\n" +
        "• Озвучивание с клонированием голоса, синхронизацией губ и улучшением губ\n" +
        "• Без рекламы и с приоритетной поддержкой\n" +
        "• Цена: US$ 179,90 в месяц или US$ 1.799,00 в год"
    }
  },

  zh: {
    free: {
      title: "Vision Free",
      details:
        "通过一次性试用免费体验。\n" +
        "• 1 个测试视频（最多 30 秒和 50MB）\n" +
        "• 强制水印\n" +
        "• 提供基础配音\n" +
        "• 处理期间显示广告\n" +
        "• 可能仅在促销期间提供\n" +
        "• 价格：US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "适合初学者的更多需求。\n" +
        "• 每月5GB（每年60GB）\n" +
        "• 每天2个视频（每个最多100MB）\n" +
        "• 视频剪辑和合并\n" +
        "• 基础配音和语音克隆\n" +
        "• 处理开始和结束时的广告\n" +
        "• 价格：US$ 9.90/月 或 US$ 99.00/年"
    },
    growth: {
      title: "Vision Growth",
      details:
        "适合小型企业或频繁创作者。\n" +
        "• 每月20GB（每年240GB）\n" +
        "• 每天5个视频（每个最多500MB）\n" +
        "• 配音、语音克隆和唇形同步\n" +
        "• 上传和退出时显示广告\n" +
        "• 适合持续内容创作\n" +
        "• 价格：US$ 69.90/月 或 US$ 699.00/年"
    },
    premium: {
      title: "Vision Premium",
      details:
        "所有功能的完整访问权限。\n" +
        "• 每月50GB（每年600GB）\n" +
        "• 每天10个视频（每个最多1GB）\n" +
        "• 配音、语音克隆、唇形同步和唇部增强\n" +
        "• 无广告，优先支持\n" +
        "• 价格：US$ 179.90/月 或 US$ 1,799.00/年"
    }
  },

  ja: {
    free: {
      title: "Vision Free",
      details:
        "一度限りの無料試用でお試しください。\n" +
        "• テスト動画1本（最大30秒・50MB）\n" +
        "• 透かし必須\n" +
        "• 基本的な吹き替え利用可能\n" +
        "• 処理中に広告表示\n" +
        "• キャンペーン期間中のみ利用可能な場合あり\n" +
        "• 価格：US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "初心者に必要な追加機能。\n" +
        "• 月5GB (年間60GB)\n" +
        "• 1日2本の動画 (最大100MB)\n" +
        "• 動画のカットと結合\n" +
        "• 基本吹き替えとボイスクローン\n" +
        "• 処理の開始と終了時に広告\n" +
        "• 価格: US$ 9.90/月 または US$ 99.00/年"
    },
    growth: {
      title: "Vision Growth",
      details:
        "小規模企業や頻繁なクリエイターに。\n" +
        "• 月20GB (年間240GB)\n" +
        "• 1日5本の動画 (最大500MB)\n" +
        "• ボイスクローンとリップシンク吹き替え\n" +
        "• アップロードと退出時に広告\n" +
        "• 継続的なコンテンツ制作に最適\n" +
        "• 価格: US$ 69.90/月 または US$ 699.00/年"
    },
    premium: {
      title: "Vision Premium",
      details:
        "全機能を無制限で利用可能。\n" +
        "• 月50GB (年間600GB)\n" +
        "• 1日10本の動画 (最大1GB)\n" +
        "• ボイスクローン、リップシンク、唇強調\n" +
        "• 広告なし、優先サポート\n" +
        "• 価格: US$ 179.90/月 または US$ 1,799.00/年"
    }
  },

  ko: {
    free: {
      title: "Vision Free",
      details:
        "1회 무료 체험으로 사용해보세요.\n" +
        "• 테스트 영상 1개 (최대 30초, 50MB)\n" +
        "• 워터마크 필수\n" +
        "• 기본 더빙 제공\n" +
        "• 처리 중 광고 표시\n" +
        "• 프로모션 기간에만 제공될 수 있음\n" +
        "• 가격: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "초보자를 위한 추가 기능.\n" +
        "• 월 5GB(연간 60GB)\n" +
        "• 하루 2개 비디오(최대 100MB)\n" +
        "• 비디오 자르기 및 결합\n" +
        "• 기본 더빙 및 음성 클론\n" +
        "• 처리 시작 및 종료 시 광고\n" +
        "• 가격: US$ 9.90/월 또는 US$ 99.00/년"
    },
    growth: {
      title: "Vision Growth",
      details:
        "소규모 기업 또는 자주 제작하는 창작자를 위한 선택.\n" +
        "• 월 20GB(연간 240GB)\n" +
        "• 하루 5개 비디오(최대 500MB)\n" +
        "• 음성 클론 및 립싱크 포함 더빙\n" +
        "• 업로드 및 종료 시 광고\n" +
        "• 지속적인 콘텐츠 제작에 적합\n" +
        "• 가격: US$ 69.90/월 또는 US$ 699.00/년"
    },
    premium: {
      title: "Vision Premium",
      details:
        "모든 기능을 무제한으로 사용할 수 있는 접근.\n" +
        "• 월 50GB(연간 600GB)\n" +
        "• 하루 10개 비디오(최대 1GB)\n" +
        "• 음성 클론, 립싱크, 입술 강조 포함 더빙\n" +
        "• 광고 없음, 우선 지원\n" +
        "• 가격: US$ 179.90/월 또는 US$ 1,799.00/년"
    }
  },

  hi: {
    free: {
      title: "विज़न फ्री",
      details:
        "एक बार के परीक्षण के साथ मुफ्त में आज़माएं।\n" +
        "• 1 परीक्षण वीडियो (अधिकतम 30 सेकंड और 50MB)\n" +
        "• वॉटरमार्क अनिवार्य\n" +
        "• बेसिक डबिंग उपलब्ध\n" +
        "• प्रोसेसिंग के दौरान विज्ञापन\n" +
        "• केवल प्रचार अवधि के दौरान उपलब्ध हो सकता है\n" +
        "• मूल्य: US$ 0"
    },
    starter: {
      title: "विज़न स्टार्टर",
      details:
        "शुरुआती लोगों के लिए अतिरिक्त सुविधाएँ।\n" +
        "• 5GB/माह (60GB/वर्ष)\n" +
        "• 2 वीडियो/दिन (अधिकतम 100MB)\n" +
        "• वीडियो कट और मर्ज\n" +
        "• बेसिक डबिंग और वॉयस क्लोनिंग\n" +
        "• प्रोसेसिंग की शुरुआत और अंत में विज्ञापन\n" +
        "• मूल्य: US$ 9.90/माह या US$ 99.00/वर्ष"
    },
    growth: {
      title: "विज़न ग्रोथ",
      details:
        "छोटे व्यवसायों या बार-बार कंटेंट बनाने वालों के लिए।\n" +
        "• 20GB/माह (240GB/वर्ष)\n" +
        "• 5 वीडियो/दिन (अधिकतम 500MB)\n" +
        "• वॉयस क्लोनिंग और लिप सिंक के साथ डबिंग\n" +
        "• अपलोड और एग्जिट पर विज्ञापन\n" +
        "• नियमित कंटेंट उत्पादन के लिए उपयुक्त\n" +
        "• मूल्य: US$ 69.90/माह या US$ 699.00/वर्ष"
    },
    premium: {
      title: "विज़न प्रीमियम",
      details:
        "सभी सुविधाओं की असीमित पहुँच।\n" +
        "• 50GB/माह (600GB/वर्ष)\n" +
        "• 10 वीडियो/दिन (अधिकतम 1GB)\n" +
        "• वॉयस क्लोनिंग, लिप सिंक और लिप एन्हांसमेंट के साथ डबिंग\n" +
        "• कोई विज्ञापन नहीं, प्राथमिकता समर्थन\n" +
        "• मूल्य: US$ 179.90/माह या US$ 1,799.00/वर्ष"
    }
  },

  ar: {
    free: {
      title: "رؤية مجانية",
      details:
        "جرّب مجانًا بتجربة واحدة فقط.\n" +
        "• فيديو تجريبي واحد (حتى 30 ثانية و50MB)\n" +
        "• علامة مائية إلزامية\n" +
        "• دبلجة أساسية متوفرة\n" +
        "• يتم عرض الإعلانات أثناء المعالجة\n" +
        "• قد يكون متاحًا فقط خلال الفترات الترويجية\n" +
        "• السعر: US$ 0"
    },
    starter: {
      title: "رؤية للمبتدئين",
      details:
        "ميزات إضافية للمبتدئين.\n" +
        "• 5GB/شهر (60GB/سنة)\n" +
        "• 2 فيديو/يوم (بحد أقصى 100MB)\n" +
        "• تقطيع ودمج الفيديو\n" +
        "• الدبلجة الأساسية مع استنساخ الصوت\n" +
        "• الإعلانات في بداية ونهاية العملية\n" +
        "• السعر: US$ 9.90 شهرياً أو US$ 99.00 سنوياً"
    },
    growth: {
      title: "رؤية للنمو",
      details:
        "لأصحاب الأعمال الصغيرة أو منشئي المحتوى المتكررين.\n" +
        "• 20GB/شهر (240GB/سنة)\n" +
        "• 5 فيديوهات/يوم (بحد أقصى 500MB)\n" +
        "• الدبلجة مع استنساخ الصوت ومزامنة الشفاه\n" +
        "• الإعلانات عند التحميل والخروج\n" +
        "• مثالي لإنتاج محتوى مستمر\n" +
        "• السعر: US$ 69.90 شهرياً أو US$ 699.00 سنوياً"
    },
    premium: {
      title: "رؤية بريميوم",
      details:
        "وصول غير محدود لجميع الميزات.\n" +
        "• 50GB/شهر (600GB/سنة)\n" +
        "• 10 वीडियोهات/يوم (بحد أقصى 1GB)\n" +
        "• الدبلجة مع استنساخ الصوت، مزامنة الشفاه وتحسين الشفاه\n" +
        "• لا إعلانات، دعم أولوي\n" +
        "• السعر: US$ 179.90 شهرياً أو US$ 1,799.00 سنوياً"
    }
  },

  tr: {
    free: {
      title: "Vision Free",
      details:
        "Tek seferlik deneme ile ücretsiz deneyin.\n" +
        "• 1 test videosu (maks. 30sn ve 50MB)\n" +
        "• Filigran zorunlu\n" +
        "• Temel dublaj mevcut\n" +
        "• İşleme sırasında reklam gösterimi\n" +
        "• Sadece promosyon dönemlerinde geçerli olabilir\n" +
        "• Fiyat: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Yeni başlayanlar için ek özellikler.\n" +
        "• Aylık 5GB (Yıllık 60GB)\n" +
        "• Günde 2 video (maks. 100MB)\n" +
        "• Video kesme ve birleştirme\n" +
        "• Temel dublaj ve ses klonlama\n" +
        "• İşlem başında ve sonunda reklamlar\n" +
        "• Fiyat: US$ 9,90/ay veya US$ 99,00/yıl"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Küçük işletmeler veya sık içerik üreticileri için.\n" +
        "• Aylık 20GB (Yıllık 240GB)\n" +
        "• Günde 5 video (maks. 500MB)\n" +
        "• Ses klonlama ve dudak senkronu içeren dublaj\n" +
        "• Yükleme ve çıkış sırasında reklamlar\n" +
        "• Sürekli içerik üretimi için mükemmel\n" +
        "• Fiyat: US$ 69,90/ay veya US$ 699,00/yıl"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Tüm özelliklere sınırsız erişim.\n" +
        "• Aylık 50GB (Yıllık 600GB)\n" +
        "• Günde 10 video (maks. 1GB)\n" +
        "• Ses klonlama, dudak senkronu ve dudak iyileştirme\n" +
        "• Reklamsız, öncelikli destek\n" +
        "• Fiyat: US$ 179,90/ay veya US$ 1.799,00/yıl"
    }
  },

  nl: {
    free: {
      title: "Vision Free",
      details:
        "Probeer gratis met een eenmalige proef.\n" +
        "• 1 testvideo (max 30s en 50MB)\n" +
        "• Watermerk verplicht\n" +
        "• Basisdubbing beschikbaar\n" +
        "• Advertenties tijdens verwerking\n" +
        "• Mogelijk alleen beschikbaar tijdens promoties\n" +
        "• Prijs: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Extra functies voor beginners.\n" +
        "• 5GB/maand (60GB/jaar)\n" +
        "• 2 video's/dag (max 100MB)\n" +
        "• Video's knippen en samenvoegen\n" +
        "• Basisdubbing en stemklonen\n" +
        "• Advertenties aan begin en eind van processen\n" +
        "• Prijs: US$ 9,90/maand of US$ 99,00/jaar"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Voor kleine bedrijven of frequente makers.\n" +
        "• 20GB/maand (240GB/jaar)\n" +
        "• 5 video's/dag (max 500MB)\n" +
        "• Dubbing met stemklonen en lip-sync\n" +
        "• Advertenties bij uploaden en afsluiten\n" +
        "• Ideaal voor continue contentproductie\n" +
        "• Prijs: US$ 69,90/maand of US$ 699,00/jaar"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Onbeperkte toegang tot alle functies.\n" +
        "• 50GB/maand (600GB/jaar)\n" +
        "• 10 video's/dag (max 1GB)\n" +
        "• Stemklonen, lip-sync en lipverbetering\n" +
        "• Geen advertenties, prioritaire ondersteuning\n" +
        "• Prijs: US$ 179,90/maand of US$ 1.799,00/jaar"
    }
  },

  sv: {
    free: {
      title: "Vision Free",
      details:
        "Prova gratis med ett engångstest.\n" +
        "• 1 testvideo (max 30s och 50MB)\n" +
        "• Vattenstämpel krävs\n" +
        "• Grundläggande dubbning tillgänglig\n" +
        "• Annonser visas under bearbetning\n" +
        "• Endast tillgänglig under kampanjperioder\n" +
        "• Pris: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Extra funktioner för nybörjare.\n" +
        "• 5GB/månad (60GB/år)\n" +
        "• 2 videor/dag (max 100MB)\n" +
        "• Klipp och slå ihop videor\n" +
        "• Grundläggande dubbning och röstkloning\n" +
        "• Annonser vid start och slut av processer\n" +
        "• Pris: US$ 9,90/månad eller US$ 99,00/år"
    },
    growth: {
      title: "Vision Growth",
      details:
        "För små företag eller frekventa skapare.\n" +
        "• 20GB/månad (240GB/år)\n" +
        "• 5 videor/dag (max 500MB)\n" +
        "• Dubbning med röstkloning och läpprörelsesynk\n" +
        "• Annonser vid uppladdning och utloggning\n" +
        "• Perfekt för kontinuerlig produktion\n" +
        "• Pris: US$ 69,90/månad eller US$ 699,00/år"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Obegränsad tillgång till alla funktioner.\n" +
        "• 50GB/månad (600GB/år)\n" +
        "• 10 videor/dag (max 1GB)\n" +
        "• Röstkloning, läpprörelsesynk och läppförbättring\n" +
        "• Inga annonser, prioriterad support\n" +
        "• Pris: US$ 179,90/månad eller US$ 1.799,00/år"
    }
  },

  no: {
    free: {
      title: "Vision Free",
      details:
        "Prøv gratis med en engangs prøve.\n" +
        "• 1 testvideo (maks 30s og 50MB)\n" +
        "• Vannmerke kreves\n" +
        "• Grunnleggende dubbing tilgjengelig\n" +
        "• Annonser vises under behandling\n" +
        "• Kan være tilgjengelig kun i kampanjeperioder\n" +
        "• Pris: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Ekstra funksjoner for nybegynnere.\n" +
        "• 5GB/måned (60GB/år)\n" +
        "• 2 videoer/dag (maks. 100MB)\n" +
        "• Klipp og slå sammen videoer\n" +
        "• Grunnleggende dubbing og stemmekloning\n" +
        "• Annonser ved start og slutt av prosesser\n" +
        "• Pris: US$ 9,90/måned eller US$ 99,00/år"
    },
    growth: {
      title: "Vision Growth",
      details:
        "For små bedrifter eller hyppige innholdsskapere.\n" +
        "• 20GB/måned (240GB/år)\n" +
        "• 5 videoer/dag (maks. 500MB)\n" +
        "• Dubbing med stemmekloning og leppesynkronisering\n" +
        "• Annonser ved opplasting og utlogging\n" +
        "• Perfekt for kontinuerlig innholdsproduksjon\n" +
        "• Pris: US$ 69,90/måned eller US$ 699,00/år"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Ubegrenset tilgang til alle funksjoner.\n" +
        "• 50GB/måned (600GB/år)\n" +
        "• 10 videoer/dag (maks. 1GB)\n" +
        "• Stemmekloning, leppesynkronisering og leppeforbedring\n" +
        "• Ingen annonser, prioritert støtte\n" +
        "• Pris: US$ 179,90/måned eller US$ 1.799,00/år"
    }
  },

  pl: {
    free: {
      title: "Vision Free",
      details:
        "Wypróbuj za darmo z jednorazowym testem.\n" +
        "• 1 film testowy (maks. 30s i 50MB)\n" +
        "• Wymagany znak wodny\n" +
        "• Dostępny podstawowy dubbing\n" +
        "• Reklamy podczas przetwarzania\n" +
        "• Może być dostępny tylko w okresach promocyjnych\n" +
        "• Cena: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Dodatkowe funkcje dla początkujących.\n" +
        "• 5GB/miesiąc (60GB/rok)\n" +
        "• 2 wideo/dzień (maks. 100MB)\n" +
        "• Cięcie i łączenie wideo\n" +
        "• Podstawowy dubbing i klonowanie głosu\n" +
        "• Reklamy przy rozpoczęciu i zakończeniu procesów\n" +
        "• Cena: US$ 9,90/mies. lub US$ 99,00/rok"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Dla małych firm lub częstych twórców treści.\n" +
        "• 20GB/miesiąc (240GB/rok)\n" +
        "• 5 wideo/dzień (maks. 500MB)\n" +
        "• Dubbing z klonowaniem głosu i synchronizacją ust\n" +
        "• Reklamy przy przesyłaniu i wylogowaniu\n" +
        "• Idealne dla stałej produkcji treści\n" +
        "• Cena: US$ 69,90/mies. lub US$ 699,00/rok"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Pełny dostęp do wszystkich funkcji.\n" +
        "• 50GB/miesiąc (600GB/rok)\n" +
        "• 10 wideo/dzień (maks. 1GB)\n" +
        "• Klonowanie głosu, synchronizacja ust i poprawa ust\n" +
        "• Brak reklam, priorytetowa pomoc\n" +
        "• Cena: US$ 179,90/mies. lub US$ 1.799,00/rok"
    }
  },

  he: {
    free: {
      title: "ויז'ן פרי",
      details:
        "נסו בחינם עם ניסיון חד פעמי.\n" +
        "• סרטון ניסיון אחד (עד 30 שניות ו-50MB)\n" +
        "• סימן מים חובה\n" +
        "• דיבוב בסיסי זמין\n" +
        "• פרסומות מוצגות במהלך העיבוד\n" +
        "• ייתכן ויהיה זמין רק בתקופות מבצע\n" +
        "• מחיר: US$ 0"
    },
    starter: {
      title: "מתחיל חזוני",
      details:
        "תכונות נוספות למתחילים.\n" +
        "• 5GB בחודש (60GB בשנה)\n" +
        "• 2 סרטונים ביום (מקסימום 100MB)\n" +
        "• חיתוך וחיבור וידאו\n" +
        "• דיבוב בסיסי ושיבוט קול\n" +
        "• פרסומות בתחילת ובסיום התהליכים\n" +
        "• מחיר: US$ 9.90 לחודש או US$ 99.00 לשנה"
    },
    growth: {
      title: "צמיחה חזונית",
      details:
        "לעסקים קטנים או יוצרים תכנים לעיתים קרובות.\n" +
        "• 20GB בחודש (240GB בשנה)\n" +
        "• 5 סרטונים ביום (מקסימום 500MB)\n" +
        "• דיבוב עם שיבוט קול וסנכרון שפתיים\n" +
        "• פרסומות בהעלאה וביציאה מהמערכת\n" +
        "• אידיאלי להפקת תוכן רציפה\n" +
        "• מחיר: US$ 69.90 לחודש או US$ 699.00 לשנה"
    },
    premium: {
      title: "פרימיום חזוני",
      details:
        "גישה מלאה לכל הפונקציות ללא הגבלות.\n" +
        "• 50GB בחודש (600GB בשנה)\n" +
        "• 10 סרטונים ביום (מקסימום 1GB)\n" +
        "• שיבוט קול, סנכרון שפתיים ושיפור שפתיים\n" +
        "• ללא פרסומות, תמיכה מועדפת\n" +
        "• מחיר: US$ 179.90 לחודש או US$ 1,799.00 לשנה"
    }
  },

  fi: {
    free: {
      title: "Vision Free",
      details:
        "Kokeile ilmaiseksi kertakokeilulla.\n" +
        "• 1 testivideo (max 30s ja 50MB)\n" +
        "• Vesileima pakollinen\n" +
        "• Perusdubbaukset saatavilla\n" +
        "• Mainokset näkyvät käsittelyn aikana\n" +
        "• Voi olla saatavilla vain kampanja-aikoina\n" +
        "• Hinta: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Lisäominaisuuksia aloittelijoille.\n" +
        "• 5GB/kk (60GB/vuosi)\n" +
        "• 2 videota/päivä (maks. 100MB)\n" +
        "• Leikkaa ja yhdistä videoita\n" +
        "• Perustason dubbing ja äänen kloonaus\n" +
        "• Mainoksia prosessien alussa ja lopussa\n" +
        "• Hinta: US$ 9,90/kk tai US$ 99,00/vuosi"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Pienyrityksille tai usein sisältöä luoville.\n" +
        "• 20GB/kk (240GB/vuosi)\n" +
        "• 5 videota/päivä (maks. 500MB)\n" +
        "• Dubbing äänikloonauksella ja huulisynkronoinnilla\n" +
        "• Mainoksia latauksessa ja uloskirjautuessa\n" +
        "• Erinomainen jatkuvaan sisällöntuotantoon\n" +
        "• Hinta: US$ 69,90/kk tai US$ 699,00/vuosi"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Täysi pääsy kaikkiin ominaisuuksiin.\n" +
        "• 50GB/kk (600GB/vuosi)\n" +
        "• 10 videota/päivä (maks. 1GB)\n" +
        "• Äänen kloonaus, huulisynkronointi ja huulien parannus\n" +
        "• Ei mainoksia, priorisoitu tuki\n" +
        "• Hinta: US$ 179,90/kk tai US$ 1.799,00/vuosi"
    }
  },

  el: {
    free: {
      title: "Vision Free",
      details:
        "Δοκιμάστε δωρεάν με μια μοναδική δοκιμή.\n" +
        "• 1 δοκιμαστικό βίντεο (μέχρι 30s και 50MB)\n" +
        "• Απαραίτητο υδατογράφημα\n" +
        "• Διαθέσιμο βασικό ντουμπλάρισμα\n" +
        "• Εμφάνιση διαφημίσεων κατά την επεξεργασία\n" +
        "• Ίσως διαθέσιμο μόνο σε περιόδους προσφορών\n" +
        "• Τιμή: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Πρόσθετες λειτουργίες για αρχάριους.\n" +
        "• 5GB/μήνα (60GB/έτος)\n" +
        "• 2 βίντεο/ημέρα (μέγ. 100MB)\n" +
        "• Κοπή και συγχώνευση βίντεο\n" +
        "• Βασική μεταγλώττιση και αντιγραφή φωνής\n" +
        "• Διαφημίσεις στην αρχή και το τέλος των διαδικασιών\n" +
        "• Τιμή: US$ 9,90/μήνα ή US$ 99,00/έτος"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Για μικρές επιχειρήσεις ή συχνούς δημιουργούς περιεχομένου.\n" +
        "• 20GB/μήνα (240GB/έτος)\n" +
        "• 5 βίντεο/ημέρα (μέγ. 500MB)\n" +
        "• Μεταγλώττιση με αντιγραφή φωνής και συγχρονισμό χειλιών\n" +
        "• Διαφημίσεις κατά τη μεταφόρτωση και την έξοδο\n" +
        "• Ιδανικό για συνεχή παραγωγή περιεχομένου\n" +
        "• Τιμή: US$ 69,90/μήνα ή US$ 699,00/έτος"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Πλήρης πρόσβαση σε όλες τις λειτουργίες.\n" +
        "• 50GB/μήνα (600GB/έτος)\n" +
        "• 10 βίντεο/ημέρα (μέγ. 1GB)\n" +
        "• Αντιγραφή φωνής, συγχρονισμός χειλιών και βελτίωση χειλιών\n" +
        "• Χωρίς διαφημίσεις, υποστήριξη προτεραιότητας\n" +
        "• Τιμή: US$ 179,90/μήνα ή US$ 1.799,00/έτος"
    }
  },

  da: {
    free: {
      title: "Vision Free",
      details:
        "Prøv gratis med en enkelt prøve.\n" +
        "• 1 testvideo (maks. 30s og 50MB)\n" +
        "• Vandmærke påkrævet\n" +
        "• Grundlæggende dubbing tilgængelig\n" +
        "• Annoncer vises under behandling\n" +
        "• Kun tilgængelig i kampagneperioder\n" +
        "• Pris: US$ 0"
    },
    starter: {
      title: "Vision Starter",
      details:
        "Ekstra funktioner til begyndere.\n" +
        "• 5GB/md (60GB/år)\n" +
        "• 2 videoer/dag (maks. 100MB)\n" +
        "• Klip og sammenflet videoer\n" +
        "• Grundlæggende dubbing og stemmekloning\n" +
        "• Annoncer ved opstart og afslutning af processer\n" +
        "• Pris: US$ 9,90/md eller US$ 99,00/år"
    },
    growth: {
      title: "Vision Growth",
      details:
        "Til små virksomheder eller hyppige skabere.\n" +
        "• 20GB/md (240GB/år)\n" +
        "• 5 videoer/dag (maks. 500MB)\n" +
        "• Dubbing med stemmekloning og læbesynkronisering\n" +
        "• Annoncer ved upload og logud\n" +
        "• Perfekt til kontinuerlig indholdsproduktion\n" +
        "• Pris: US$ 69,90/md eller US$ 699,00/år"
    },
    premium: {
      title: "Vision Premium",
      details:
        "Fuld adgang til alle funktioner.\n" +
        "• 50GB/md (600GB/år)\n" +
        "• 10 videoer/dag (maks. 1GB)\n" +
        "• Stemmekloning, læbesynkronisering og forbedring\n" +
        "• Ingen annoncer, prioriteret support\n" +
        "• Pris: US$ 179,90/md eller US$ 1.799,00/år"
    }
  }
};

export default tooltipTranslations;
